/**
 * Etapes de validation du cycle de vie d'un mandat, entre la création et l'archivage
 * Décrites côté serveur dans SMAAttribute (LifecycleSteps)
 */
enum SMALifecycleStepEnum
{
    ClientValidation = 1,
    SupervisorValidation = 2
}

export default SMALifecycleStepEnum;